import { classifyRepo, isEmptyRepo } from '../projects/import/repoState';
import type { Repository } from '../../types';

/**
 * Returns true if the repo should appear as a row in the bulk-import modal.
 * Hides currently-connected repos and empty repositories; surfaces disconnected
 * repos so the user can bulk reconnect them.
 */
export function isRepoVisibleForBulkImport(repo: Repository): boolean {
  if (isEmptyRepo(repo)) {
    return false;
  }

  const state = classifyRepo(repo);
  return state === 'disconnected' || state === 'unimported';
}
